import { Injectable } from '@angular/core';
import {
  DynamicOrchestrator,
  OrchestratorComponents,
  OrchestratorForm,
} from '@games/shared/orchestrator';

@Injectable()
export class SpeedreadingHeaderOrchestrator extends DynamicOrchestrator {
  provideAny() {
    this.form({
      padding: {
        height: 10,
        bottom: 2,
        for: 'orchestrator',
      },
      column: [
        {
          for: 'header',
          padding: {
            width: 10,
            height: 10,
            horizontal: 0.2,
            vertical: 1,
            for: 'header',
          },
        },
      ],
    });
  }
}
